import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchOutlined } from '@ant-design/icons'
import type { TableProps } from 'antd'
import { Button, Input, Select, Table } from 'antd'

import { useNavigation, useUsers } from '@/hooks'
import { User } from '@/utils/UserData'

export const UsersPage = () => {
  const { t, i18n } = useTranslation()
  const navigation = useNavigation()
  const users = useUsers()

  const [searchValue, setSearchValue] = useState('')
  const [type, setType] = useState<'list' | 'table'>('list')

  const userList = useMemo(() => users.query.data ?? [], [users.query.data])

  const columns: TableProps<User>['columns'] = useMemo(
    () => [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        sorter: (a, b) => a.id - b.id,
      },
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.length - b.name.length,
      },
      {
        title: t('Email'),
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => a.email.length - b.email.length,
      },
      {
        title: t('Action'),
        key: 'action',
      },
    ],
    [i18n.language],
  )

  return (
    <div>
      <div className="flex flex-row justify-between p-8 pt-10">
        <div className="flex flex-row items-center gap-2">
          <Button type="primary" onClick={navigation.goBack}>
            ←
          </Button>
          <div className="text-4xl font-bold text-slate-800">Users List</div>
        </div>
        <div className="flex flex-row items-center gap-2">
          <Input
            className="w-auto min-w-32"
            name="name"
            type="text"
            prefix={<SearchOutlined />}
            onChange={console.log}
          />
          <Select
            className="w-auto min-w-32"
            options={[
              { label: 'All', value: 'all' },
              { label: 'Admin', value: 'admin' },
              { label: 'User', value: 'user' },
            ]}
            defaultValue="all"
            onChange={(value) => {
              console.log(value)
            }}
          />
          <Button type="primary">+</Button>
        </div>
      </div>
      <div className="p-8">
        <Table columns={columns} dataSource={userList} />
      </div>
    </div>
  )
}
